import dealerCashUnfreezing from './cash_unfreezing.vue';

export default dealerCashUnfreezing;
